<script setup lang="ts">
defineProps<{
  icon: string
  text: string
}>()
</script>

<template>
  <div class="flex items-center">
    <Icon class="text-lg" :name="icon" />
    <p class="ml2 text-sm text-muted-foreground">
      {{ text }}
    </p>
  </div>
</template>
